query (
    $filter: CompetitionFilter
) {
    competitions: allCompetitions (
        filter: $filter
    ) {
        nodes {
            competitionId: competitionId
            competitionName: competitionName
            region {
                regionId: regionId
                regionName: regionName
            }
            appliedTemplates: competitionAppliedTemplatesByCompetitionId {
                nodes {
                    sportTemplateId: appliedSportTemplateId
                }
            }
        }
    }
}
